import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);
  return (
    <div data-testid="admin-users-page" className="space-y-4">
      <h1 className="font-display font-extrabold text-3xl">Users</h1>
      <div className="hs-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6] text-[11px] uppercase font-mono text-[#4B5563]">
            <tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Email</th><th className="text-left px-4 py-3">Role</th><th className="text-left px-4 py-3">Created</th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-[#E2E8F0]" data-testid={`user-row-${u.id}`}>
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4 py-3 font-mono text-xs">{u.email}</td>
                <td className="px-4 py-3"><span className="text-[10px] font-mono px-2 py-0.5 bg-[#F3F4F6]">{u.role}</span></td>
                <td className="px-4 py-3 text-xs text-[#4B5563]">{u.created_at?.slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
